import React, { useEffect } from 'react';
import { useBooking } from './hooks/Booking.hook';
import BookingView from './views/BookingView';
import LoadingComponent from '@/components/general/Loading/LoadingComponent';

const BookingController = (props) => {
  const { className, spaceDetail, backButton } = props;
  const { isLoading, doCheckout } = useBooking(spaceDetail);
  if (isLoading) {
    return <LoadingComponent loading={isLoading} />;
  } else {
    return (
      <BookingView
        className={className}
        spaceDetail={spaceDetail}
        onSubmitFunction={doCheckout}
        backButton={backButton}
      />
    );
  }
};

export default BookingController;
